// extracted by mini-css-extract-plugin
module.exports = {"modal":"ModalBase_modal__Bqarp","clickPassthrough":"ModalBase_clickPassthrough__TYLd_","basicModal":"ModalBase_basicModal__2Bu2W"};